export interface IUser {
  id: string;
  name: string;
  lastName: string;
  email: string;
  activeTournaments: string[];
  historyTournaments: string[];
  sequentialUserId: number;
  password?: string;
  ghinNumber?: string;
  handicap?: number;
  lastCourses?: string[];
  disabled?: boolean;
  isAdmin?: boolean;
}

export default class UserModel implements IUser {
  id = "";
  name = "";
  lastName = "";
  email = "";
  password? = "";
  ghinNumber? = "";
  handicap? = 0;
  sequentialUserId = 0;
  activeTournaments = [] as string[];
  historyTournaments = [] as string[];
  lastCourses = [] as string[];
  disabled = false;
  isAdmin? = false;
  constructor(init?: Partial<UserModel>) {
    Object.assign(this, init);
  }
}
